import {useContext, useEffect, useState} from "react";
import {ApiContext} from "../../util/Requests";
import EditableAutoCompleteBase from "./EditableAutoCompleteBase";
import DepartmentPreviewModal from "../modals/previews/DepartmentPreviewModal";
import {SC_Department} from "../../util/api/enums/SC_Department";


const EditableCardEntryDepartmentBase = ({fancy = false, isEditing, onEdit, baseValue, displayLabel = "Department", filterFunction = () => true, isMultiSelect = false, showPCID = false}) => {
    const {caches} = useContext(ApiContext);

    // Use the passed items (departments) or default to empty array
    const departments = SC_Department.VALUES;

    console.log(departments, baseValue);

    // Handle both single and multi-select cases
    let selectedDepartments;
    if (isMultiSelect) {
        selectedDepartments = (baseValue ? baseValue : []).map(v => departments.find(dept => dept.key === v)).filter(v => v);
    } else {
        selectedDepartments = baseValue ? (departments.find(dept => dept.key === baseValue)) ?? {} : {};
    }

    const selectedNames = <div>{isMultiSelect
        ? selectedDepartments.map(it => <span style={{display: "block"}}>{it.value}</span>)
        : <span>{selectedDepartments.value}</span>}</div>;

    // console.log(selectedNames, selectedDepartments, baseValue);

    return <EditableAutoCompleteBase
        label={displayLabel}
        defaultValue={isMultiSelect ? selectedDepartments.map(it => it.key) : selectedDepartments.value}
        items={departments.filter(filterFunction)}
        idKey={"key"}
        nameKey={"value"}
        placeholder={`Department${isMultiSelect ? 's' : ''}`}
        onSelect={onEdit}
        displayValue={
        isMultiSelect ?
            (selectedDepartments.length ?
                selectedNames :
                <i>No Departments</i>
            ) :
            (selectedDepartments ?
                selectedNames :
                "???"
            )
        }
        cancelButton={!isMultiSelect}
        isEditing={isEditing}
        multiSelect={isMultiSelect}
        onCancel={!isMultiSelect ? () => onEdit(-1) : () => {}}
    />
}

export default EditableCardEntryDepartmentBase;
